
<img
  @click="goToHome()"
  class="logo-image cursor-pointer"
  src="@/images/container_alliance_logo.svg"
  alt="container alliance logo"
/>
